
import { React, useState, useEffect } from "react";
import Echarts from "echarts-for-react";
import * as echarts from "echarts/core";
import {
  getDate,
  getTime,
  getDay,
  formatYaxisNumber,
} from "components/common/dateTime";
import { useWindowSize } from "services/resizeservice";

export default function SitePerformance(props) {
  const [echartInstance, setEchartInstance] = useState(null);
  const size = useWindowSize();

  useEffect(() => {
    echartInstance?.resize();
  }, [size.width]);

  var options = () => ({
    color: ["#9AAB04", "#1CAF9A", "#FFC600", "#FFC600", "#43BFE5"],
    tooltip: {
      trigger: "axis",
    },
    legend: {
      type: "scroll",
      //padding: 25,
      show: true,
      itemGap: 5,
      itemWidth: 8,
      top: "1px",
      icon: "circle",
      left: "1.5%",
      textStyle: {
        fontSize: "11",
        fontFamily: "JioType",
        fontStyle: "normal",
        color: "#9F9F9F",
      },
    },
    xAxis: {
      type: "category",
      boundaryGap: false,
      data: props.performanceDataLabel,
    },
    grid: {
      top: "14%",
      bottom: "30%",
      left: "20%",
    },
    yAxis: {
      type: "value",
      name: "Energy Discharge (in KWh) till Date",
      nameLocation: "middle",
      nameGap: 30,
      axisLabel: {
        formatter: formatYaxisNumber,
      },
    },
    series: props.performanceDataLabelVal,
  });
  return (
    <div>
      <Echarts
        styles={{ with: "100%", height: "80%" }}
        echarts={echarts}
        notMerge={true}
        lazyUpdate={true}
        theme={"theme_name"}
        onChartReady={(instance) => {
          setEchartInstance(instance);
        }}
        opts={{ renderer: "svg" }}
        option={options()}
      />
    </div>
  );
}
